"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.form.basicInfo': 'Informazioni di Base',
    'tutorial.form.name': 'Nome del Tutorial',
    'tutorial.form.description': 'Descrizione',
    'tutorial.form.introText': 'Testo di Introduzione',
    'tutorial.form.active': 'Attivo',
    'tutorial.form.steps': 'Passaggi di Apprendimento',
    'tutorial.form.stepsDescription': 'Seleziona i passaggi di apprendimento da includere in questo tutorial.',
    'tutorial.form.noStepsAvailable': 'Nessun passaggio di apprendimento disponibile. Crea prima alcuni passaggi.',
    'tutorial.form.sections': 'Sezioni del Tutorial',
    'tutorial.form.addSection': 'Aggiungi Sezione',
    'tutorial.form.sectionsDescription': 'Crea sezioni con conoscenza specifica e prompt per l\'apprendimento guidato.',
    'tutorial.form.section': 'Sezione',
    'tutorial.form.sectionTitle': 'Titolo della Sezione',
    'tutorial.form.sectionDescription': 'Descrizione della Sezione',
    'tutorial.form.sectionPrompt': 'Prompt della Sezione',
    'tutorial.form.sectionKnowledge': 'Base di Conoscenza',
    'tutorial.form.namePlaceholder': 'Inserisci il nome del training...',
    'tutorial.form.avatar': 'Avatar Principale',
    'tutorial.form.avatarPlaceholder': 'Scegli un avatar per questo tutorial',
    'tutorial.form.selectAvatar': 'Seleziona Avatar...',
    'tutorial.form.company': 'Azienda / Assegnazione',
    'tutorial.form.selectCompany': 'Seleziona Azienda...',
    'tutorial.form.descriptionPlaceholder': 'Descrivi brevemente cosa copre questo training...',
    'tutorial.form.introTextPlaceholder': 'Scrivi un testo di introduzione che accoglie il partecipante...',
    'tutorial.form.step': 'Passo',
    'tutorial.form.addStep': 'Aggiungi Passo',
    'tutorial.form.stepName': 'Nome del Passo',
    'tutorial.form.stepNamePlaceholder': 'Inserisci il nome del passo',
    'tutorial.form.stepDescription': 'Descrizione del Passo',
    'tutorial.form.stepDescriptionPlaceholder': 'Inserisci la descrizione del passo (opzionale)',
    'tutorial.form.selectStep': 'Seleziona Passo...',
    'tutorial.form.sectionName': 'Nome della Sezione',
    'tutorial.form.sectionNamePlaceholder': 'Inserisci il nome della sezione...',
    'tutorial.form.sectionIntro': 'Introduzione della Sezione',
    'tutorial.form.sectionIntroPlaceholder': 'Descrivi cosa imparerà il partecipante in questa sezione...',
    'tutorial.form.sectionPromptPlaceholder': 'Fornisci conoscenza o guida per questa sezione...',
    'tutorial.form.addKnowledge': 'Aggiungi Conoscenza',
    'tutorial.form.selectedKnowledge': 'Conoscenza Selezionata',
    'tutorial.form.files': 'Screenshot / Schermo',
    'tutorial.form.screenshot': 'Screenshot / Schermo',
    'tutorial.form.screenshotPlaceholder': 'Seleziona file screenshot...',
    'tutorial.form.video': 'Video (MP4)',
    'tutorial.form.videoPlaceholder': 'Seleziona file video...',
    'tutorial.form.screenshotMini': 'Miniatura screenshot',
    'tutorial.form.screenshotMiniPlaceholder': 'Seleziona miniatura screenshot...',
    'tutorial.form.videoMini': 'Miniatura video',
    'tutorial.form.videoMiniPlaceholder': 'Seleziona miniatura video...',
    'tutorial.form.attachments': 'Allegati',
    'tutorial.form.addFile': 'Aggiungi file',
    'tutorial.form.sectionFileMiniature': 'Immagine miniatura',
    'tutorial.form.sectionFileRequired': 'Seleziona un file prima di aggiungerlo.',
    'tutorial.form.source.label': 'Fonte',
    'tutorial.form.source.ai': 'Generato da IA',
    'tutorial.form.source.file': 'Scansiona il file sorgente e genera il tutorial',
    'tutorial.form.sourceFile.label': 'File Fonte',
    'tutorial.form.sourceFile.placeholder': 'Seleziona file fonte...',
    'tutorial.form.scanPages.label': 'Intervallo di pagine dell’indice / sommario',
    'tutorial.form.scanSourceFile': 'Scansiona il file sorgente e compila il modulo del tutorial',
    'tutorial.form.regenerateFromPdf': 'Rigenera dal file sorgente',
    'tutorial.form.regenerateFromPdf.title': 'Rigenerare il tutorial dal file sorgente?',
    'tutorial.form.regenerateFromPdf.confirm': 'Il contenuto del tutorial verrà rigenerato dal file sorgente e potrebbe sostituire quello esistente. Vuoi continuare?',
    'tutorial.form.tutorialGoal': 'Obiettivo del tutorial',
    'tutorial.form.tutorialGoalPlaceholder': 'Descrivi cosa il partecipante dovrebbe saper fare dopo aver completato questo tutorial...',
    'tutorial.form.examplePrompts_1': 'Crea un tutorial per principianti sui fondamenti dello sci, con passaggi, sezioni e attività da svolgere',
    'tutorial.form.examplePrompts_2': 'Riscrivi la descrizione e il testo introduttivo in modo che corrispondano all\'obiettivo del tutorial',
    'tutorial.form.examplePrompts_3': 'Aggiungi una breve lista di attività da svolgere a ogni sezione di questo tutorial',
    'tutorial.form.scanNeedsData': 'Compila almeno il nome, l\'obiettivo o la descrizione (o aggiungi dei passaggi) così l\'IA avrà qualcosa da ampliare',
    'tutorial.form.start.title': 'Come vuoi iniziare?',
    'tutorial.form.start.onboarding.title': 'Creatore di corsi con IA',
    'tutorial.form.start.onboarding.description': 'Rispondi a un breve questionario guidato sul tuo corso. L\'IA darà forma al tutorial in base alle tue risposte.',
    'tutorial.form.start.onboarding.action': 'Inizia il questionario guidato',
    'tutorial.form.start.form.title': 'Tutorial vuoto',
    'tutorial.form.start.form.description': 'Compila il modulo da solo, scansiona un file sorgente o chiedi aiuto all\'assistente IA. Puoi aggiungere l\'onboarding più tardi dall\'intestazione del modulo.',
    'tutorial.form.start.form.action': 'Apri il modulo',
    'tutorial.form.start.form.how.title': 'Come funziona',
    'tutorial.form.start.form.how.step1': 'Dai un nome al tutorial, scegli una categoria e aggiungi descrizione e logo.',
    'tutorial.form.start.form.how.step1.title': 'Imposta le informazioni di base',
    'tutorial.form.start.form.how.step2': 'Crea passaggi e sezioni, poi disponili nell\'ordine che seguiranno i partecipanti.',
    'tutorial.form.start.form.how.step2.title': 'Crea la struttura',
    'tutorial.form.start.form.how.step3': 'Aggiungi contenuti e allegati come file, immagini e video.',
    'tutorial.form.start.form.how.step3.title': 'Aggiungi i materiali didattici',
    'tutorial.form.start.form.how.step4': 'Aggiungi attività che i partecipanti potranno spuntare durante l\'apprendimento.',
    'tutorial.form.start.form.how.step4.title': 'Aggiungi le attività',
    'tutorial.form.start.how.title': 'Come funziona',
    'tutorial.form.start.how.step1': 'Completi un breve questionario passo dopo passo: nozioni di base del corso, pubblico, struttura e durata, stile di insegnamento, materiali, modello di apprendimento e certificazione.',
    'tutorial.form.start.how.step1.title': 'Rispondi ad alcune domande',
    'tutorial.form.start.how.step2': 'Le tue risposte vengono allegate al tutorial e salvate insieme ad esso.',
    'tutorial.form.start.how.step2.title': 'Salva le risposte con il tutorial',
    'tutorial.form.start.how.step3': 'L\'IA le usa come istruzioni ogni volta che genera contenuti - nell\'assistente IA e durante la scansione di un file sorgente - così struttura, profondità, tono ed esercizi corrispondono alle tue scelte.',
    'tutorial.form.start.how.step3.title': 'Adatta i contenuti alle tue preferenze',
    'tutorial.form.assistant': 'Assistente',
    'tutorial.scanned': 'Tutorial analizzato e modulo compilato con successo',
    'tutorial.scanFailed': 'Impossibile analizzare il tutorial',
    'tutorial.category.loadFailed': 'Impossibile caricare le categorie',
    'tutorial.form.expireAt': 'Data di scadenza',
    'tutorial.form.scanKnowledge.label': 'Oppure usa una voce di conoscenza come fonte di scansione',
    'tutorial.form.scanKnowledge.none': 'Nessuna voce di conoscenza selezionata',
    'tutorial.form.source.ai.description': 'Il contenuto del tutorial verrà generato dall\'IA in tempo reale.',
    'tutorial.form.source.file.description': 'Carica un file sorgente (es. PDF). Il suo indice viene scansionato per costruire il tutorial.',
    'tutorial.form.scanSourceFile.description.ai': 'L\'IA analizzerà i dati già inseriti e completerà la struttura mancante del tutorial (sezioni e passaggi).',
    'tutorial.form.scanSourceFile.description.file': 'Il file sorgente verrà scansionato per generare l\'intera struttura del tutorial e i suoi contenuti (sezioni, passaggi e testi).',
    'tutorial.form.onboardingAttached': 'Onboarding allegato',
    'tutorial.form.scanProgress.step': 'Passaggio',
    'tutorial.form.scanProgress.section': 'Sezione',
    'tutorial.form.scanProgress.reading': 'Lettura del file sorgente...',
    'tutorial.form.scanProgress.index': 'Analisi della struttura e pianificazione delle sezioni...',
    'tutorial.form.scanProgress.content': 'Scrittura del contenuto della sezione',
    'tutorial.form.scanProgress.todos': 'Creazione delle attività',
    'tutorial.form.source_pages': 'Pagine di origine della sezione',
    'tutorial.form.category': 'Categoria',
    'tutorial.form.no_cat': 'Nessuna categoria',
    'tutorial.form.logo': 'Logo del Tutorial',
    'tutorial.form.todoItems': 'Elementi Todo',
    'tutorial.form.todoItemPlaceholder': 'Inserisci elemento todo...',
    'tutorial.form.todoDescription': 'Gestisci la lista todo per questo tutorial',
    'tutorial.form.addTodoItem': 'Aggiungi Todo',
    'tutorial.form.removeTodoItem': 'Rimuovi Todo',
    'tutorial.form.noTodoItems': 'Nessun elemento todo per questo tutorial',
    'tutorial.form.updatedFromAI': 'Modulo aggiornato dall\'assistente AI',
    // Onboarding wizard
    'tutorial.form.onboarding.button': 'Onboarding',
    'tutorial.form.onboarding.submit': 'Genera corso',
    'tutorial.form.onboarding.stepLabel': 'Passo',
    'tutorial.form.onboarding.step1': 'Informazioni di base',
    'tutorial.form.onboarding.step2': 'Destinatari',
    'tutorial.form.onboarding.step3': 'Parametri del corso',
    'tutorial.form.onboarding.step4': 'Stile del corso',
    'tutorial.form.onboarding.step5': 'Materiali da generare',
    'tutorial.form.onboarding.step6': 'Multimedia',
    'tutorial.form.onboarding.step7': 'Modello di apprendimento',
    'tutorial.form.onboarding.step8': 'Certificazione',
    'tutorial.form.onboarding.name': 'Nome del corso',
    'tutorial.form.onboarding.category': 'Categoria',
    'tutorial.form.onboarding.goals': 'Obiettivo del corso',
    'tutorial.form.onboarding.description': 'Descrizione del corso (max 2000 caratteri)',
    'tutorial.form.onboarding.level': 'Livello di conoscenza',
    'tutorial.form.onboarding.participants': 'Numero di partecipanti',
    'tutorial.form.onboarding.industries': 'Settore',
    'tutorial.form.onboarding.targetGroups': 'Gruppo target',
    'tutorial.form.onboarding.totalHours': 'Durata totale del corso',
    'tutorial.form.onboarding.modulesCount': 'Numero di passaggi',
    'tutorial.form.onboarding.lessonsPerModule': 'Sezioni per passaggio',
    'tutorial.form.onboarding.lessonMinutes': 'Durata media della sezione',
    'tutorial.form.onboarding.intensity': 'Intensità',
    'tutorial.form.onboarding.styles': 'Stile di insegnamento',
    'tutorial.form.onboarding.tone': 'Tono di comunicazione',
    'tutorial.form.onboarding.materials': 'L\'AI deve creare',
    'tutorial.form.onboarding.aiAvatar': 'Avatar AI',
    'tutorial.form.onboarding.slides': 'Genera slide',
    'tutorial.form.onboarding.narration': 'Genera narrazione',
    'tutorial.form.onboarding.quizVideo': 'Genera quiz video',
    'tutorial.form.onboarding.graphics': 'Genera grafiche',
    'tutorial.form.onboarding.graphicsStyle': 'Stile delle grafiche',
    'tutorial.form.onboarding.theoryPracticeRatio': 'Teoria ←→ Pratica',
    'tutorial.form.onboarding.exercisesCount': 'Numero di esercizi',
    'tutorial.form.onboarding.caseStudiesCount': 'Numero di case study',
    'tutorial.form.onboarding.finalProject': 'Progetto finale',
    'tutorial.form.onboarding.finalExam': 'Esame finale',
    'tutorial.form.onboarding.certificate': 'Certificato di completamento',
    'tutorial.form.onboarding.passThreshold': 'Soglia di superamento',
    'tutorial.form.onboarding.numbered': 'Certificato numerato',
    'tutorial.form.onboarding.qrVerification': 'Verifica del certificato tramite QR',
    'tutorial.form.onboarding.goals.knowledge': 'Acquisire conoscenze',
    'tutorial.form.onboarding.goals.skills': 'Acquisire competenze',
    'tutorial.form.onboarding.goals.certification': 'Certificazione',
    'tutorial.form.onboarding.goals.process_implementation': 'Implementazione di un processo',
    'tutorial.form.onboarding.goals.sales_increase': 'Aumento delle vendite',
    'tutorial.form.onboarding.goals.company_automation': 'Automazione aziendale',
    'tutorial.form.onboarding.goals.career_growth': 'Crescita professionale',
    'tutorial.form.onboarding.goals.exam_preparation': 'Preparazione all\'esame',
    'tutorial.form.onboarding.levels.beginner': 'Principiante',
    'tutorial.form.onboarding.levels.intermediate': 'Intermedio',
    'tutorial.form.onboarding.levels.advanced': 'Avanzato',
    'tutorial.form.onboarding.levels.expert': 'Esperto',
    'tutorial.form.onboarding.industries.b2b': 'B2B',
    'tutorial.form.onboarding.industries.ecommerce': 'E-commerce',
    'tutorial.form.onboarding.industries.services': 'Servizi',
    'tutorial.form.onboarding.industries.production': 'Produzione',
    'tutorial.form.onboarding.industries.accounting': 'Contabilità',
    'tutorial.form.onboarding.industries.it': 'IT',
    'tutorial.form.onboarding.industries.education': 'Istruzione',
    'tutorial.form.onboarding.industries.real_estate': 'Immobiliare',
    'tutorial.form.onboarding.industries.medicine': 'Medicina',
    'tutorial.form.onboarding.industries.other': 'Altro',
    'tutorial.form.onboarding.targetGroups.business_owners': 'Titolari d\'azienda',
    'tutorial.form.onboarding.targetGroups.ceo': 'CEO',
    'tutorial.form.onboarding.targetGroups.managers': 'Manager',
    'tutorial.form.onboarding.targetGroups.sales': 'Venditori',
    'tutorial.form.onboarding.targetGroups.hr': 'HR',
    'tutorial.form.onboarding.targetGroups.marketing': 'Marketing',
    'tutorial.form.onboarding.targetGroups.developers': 'Sviluppatori',
    'tutorial.form.onboarding.targetGroups.freelancers': 'Freelance',
    'tutorial.form.onboarding.targetGroups.employees': 'Dipendenti',
    'tutorial.form.onboarding.intensities.micro_learning': 'Micro-learning',
    'tutorial.form.onboarding.intensities.standard': 'Standard',
    'tutorial.form.onboarding.intensities.academy': 'Accademia',
    'tutorial.form.onboarding.intensities.masterclass': 'Masterclass',
    'tutorial.form.onboarding.styles.expert': 'Esperto',
    'tutorial.form.onboarding.styles.business': 'Aziendale',
    'tutorial.form.onboarding.styles.formal': 'Formale',
    'tutorial.form.onboarding.styles.practical': 'Pratico',
    'tutorial.form.onboarding.styles.coaching': 'Coaching',
    'tutorial.form.onboarding.styles.storytelling': 'Storytelling',
    'tutorial.form.onboarding.styles.mentoring': 'Mentoring',
    'tutorial.form.onboarding.styles.workshop': 'Workshop',
    'tutorial.form.onboarding.tones.professional': 'Professionale',
    'tutorial.form.onboarding.tones.friendly': 'Amichevole',
    'tutorial.form.onboarding.tones.dynamic': 'Dinamico',
    'tutorial.form.onboarding.tones.premium': 'Premium',
    'tutorial.form.onboarding.tones.corporate': 'Aziendale formale',
    'tutorial.form.onboarding.materials.outline': 'Scaletta',
    'tutorial.form.onboarding.materials.full_lessons': 'Contenuti completi delle lezioni',
    'tutorial.form.onboarding.materials.presentations': 'Presentazioni',
    'tutorial.form.onboarding.materials.pdf': 'PDF',
    'tutorial.form.onboarding.materials.workbook': 'Quaderno degli esercizi',
    'tutorial.form.onboarding.materials.checklists': 'Checklist',
    'tutorial.form.onboarding.materials.quizzes': 'Quiz',
    'tutorial.form.onboarding.materials.exams': 'Esami',
    'tutorial.form.onboarding.materials.certificate': 'Certificato',
    'tutorial.form.onboarding.materials.practical_tasks': 'Esercizi pratici',
    'tutorial.form.onboarding.materials.worksheets': 'Schede di lavoro',
    'tutorial.form.onboarding.materials.prompt_pack': 'Prompt Pack',
    'tutorial.form.onboarding.materials.case_study': 'Caso di studio',
    'tutorial.form.onboarding.materials.landing_page': 'Landing page',
    'tutorial.form.onboarding.materials.sales_webinar': 'Webinar di vendita',
    'tutorial.form.onboarding.materials.email_campaign': 'Campagna e-mail',
    'tutorial.form.onboarding.materials.social_posts': 'Post sui social media',
    'tutorial.form.onboarding.materials.meta_ads': 'Annunci Meta',
    'tutorial.form.onboarding.materials.google_ads': 'Annunci Google',
    'tutorial.form.onboarding.imageStyles.photorealistic': 'Fotorealistico',
    'tutorial.form.onboarding.imageStyles.corporate': 'Corporate',
    'tutorial.form.onboarding.imageStyles.minimalist': 'Minimalista',
    'tutorial.form.onboarding.imageStyles.3d': '3D',
    'tutorial.form.onboarding.imageStyles.infographic': 'Infografiche',
    'tutorial.form.onboarding.imageStyles.comic': 'Fumetto',
    'tutorial.form.onboarding.imageStyles.premium': 'Premium',
    'tutorial.form.sourcePreview': 'Anteprima della fonte',
    'tutorial.form.editor.addField': 'Aggiungi campo',
    'tutorial.form.editor.addOption': 'Aggiungi opzione',
    'tutorial.form.editor.fieldType': 'Tipo di campo',
    'tutorial.form.editor.label': 'Etichetta',
    'tutorial.form.editor.max': 'Max',
    'tutorial.form.editor.min': 'Min',
    'tutorial.form.editor.moveDown': 'Sposta giù',
    'tutorial.form.editor.moveUp': 'Sposta su',
    'tutorial.form.editor.multiple': 'Selezione multipla',
    'tutorial.form.editor.name': 'Nome',
    'tutorial.form.editor.optionLabel': 'Etichetta dell\'opzione',
    'tutorial.form.editor.optionValue': 'Valore dell\'opzione',
    'tutorial.form.editor.options': 'Opzioni',
    'tutorial.form.editor.placeholder': 'Segnaposto',
    'tutorial.form.editor.remove': 'Rimuovi',
    'tutorial.form.editor.required': 'Obbligatorio',
    'tutorial.form.editor.rows': 'Righe',
    'tutorial.form.editor.showValue': 'Mostra valore',
    'tutorial.form.editor.step': 'Passo',
    'tutorial.form.editor.submitLabel': 'Etichetta del pulsante di invio',
    'tutorial.form.editor.type': 'Tipo',
    'tutorial.form.editor.unit': 'Unità',
    'tutorial.form.editor.fieldType.input': 'Campo di testo',
    'tutorial.form.editor.fieldType.textarea': 'Area di testo',
    'tutorial.form.editor.fieldType.select': 'Menu a discesa',
    'tutorial.form.editor.fieldType.radio': 'Pulsanti di opzione',
    'tutorial.form.editor.fieldType.checkbox': 'Casella di controllo',
    'tutorial.form.editor.fieldType.date': 'Data',
    'tutorial.form.editor.fieldType.switch': 'Interruttore',
    'tutorial.form.editor.fieldType.slider': 'Cursore',
    'tutorial.form.editor.inputFieldType.text': 'Testo',
    'tutorial.form.editor.inputFieldType.number': 'Numero',
    'tutorial.form.editor.inputFieldType.email': 'Email',
    'tutorial.form.editor.inputFieldType.password': 'Password',
    'tutorial.form.editor.inputFieldType.tel': 'Telefono',
    'tutorial.form.editor.inputFieldType.url': 'URL',
    'tutorial.form.editor.inputFieldType.search': 'Ricerca',
    'tutorial.form.editor.inputFieldType.date': 'Data',
    'tutorial.form.editor.inputFieldType.datetime-local': 'Data e ora',
    'tutorial.form.editor.inputFieldType.time': 'Ora',
    'tutorial.form.editor.defaultSubmitLabel': 'Invia',
    'tutorial.form.editor.defaultFieldLabel': 'Nuovo campo',
    'tutorial.form.editor.defaultOptionLabel': 'Opzione {index}',
    'tutorial.form.editor.formEditor': 'Editor del modulo',
    'tutorial.form.editor.formIncluded': 'Modulo aggiunto',
    'tutorial.form.editor.saveForm': 'Salva modulo',
};
